(() => {
const init = () => {
const dialog = document.getElementById('HairifyUpsellDialog');
if (!dialog) return;
const addButton = dialog.querySelector('[data-hairify-upsell-add]');
const skipButton = dialog.querySelector('[data-hairify-upsell-skip]');
const closeButton = dialog.querySelector('[data-hairify-upsell-close]');
const feedback = dialog.querySelector('[data-hairify-upsell-feedback]');
const checkboxes = Array.from(dialog.querySelectorAll('.hairify-upsell__checkbox'));
const fiberProductId = Number(dialog.dataset.fiberProductId);
const fiberVariantsNode = dialog.querySelector('[data-hairify-fiber-variants]');
const fiberVariantIds = new Set(JSON.parse(fiberVariantsNode?.textContent || '[]').map(Number));
let restoreFocusTo = null;
let lastFiberTriggerAt = 0;
let lastKnownFiberQuantity = null;
const track = (eventName, detail = {}) => {
if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: eventName, ...detail });
if (typeof window.clarity === 'function') window.clarity('event', eventName);
document.dispatchEvent(new CustomEvent(eventName, { detail }));
};
const getCart = async () => {
const response = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
if (!response.ok) throw new Error('cart');
return response.json();
};
const refreshCartIcon = async () => {
try {
const response = await fetch(window.routes.cart_url + '?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } });
if (!response.ok) return;
const sections = await response.json();
const html = sections['cart-icon-bubble'];
if (!html) return;
const replacement = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-icon-bubble');
const current = document.getElementById('cart-icon-bubble');
if (current && replacement) current.innerHTML = replacement.innerHTML;
} catch (_) {}
};
const setFeedback = (message = '', type = '') => {
feedback.textContent = message;
feedback.classList.toggle('is-error', type === 'error');
feedback.classList.toggle('is-success', type === 'success');
};
const updateButtonState = () => {
addButton.disabled = !checkboxes.some((checkbox) => checkbox.checked && !checkbox.disabled);
};
const setItemState = (checkbox, state, text) => {
const item = checkbox.closest('[data-hairify-upsell-item]');
const stateNode = item?.querySelector('[data-hairify-upsell-state]');
if (!item || !stateNode) return;
item.classList.toggle('is-disabled', state !== 'ready');
checkbox.disabled = state !== 'ready';
if (state !== 'ready') checkbox.checked = false;
stateNode.hidden = state === 'ready';
stateNode.textContent = state === 'ready' ? '' : text;
};
const getFiberQuantity = (cart) => (cart?.items || [])
.filter((item) => Number(item.product_id) === fiberProductId)
.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
const syncWithCart = async () => {
const cart = await getCart();
lastKnownFiberQuantity = getFiberQuantity(cart);
const inCartVariants = new Set(cart.items.map((item) => Number(item.variant_id)));
checkboxes.forEach((checkbox) => {
const item = checkbox.closest('[data-hairify-upsell-item]');
const available = item?.dataset.available === 'true';
const alreadyInCart = inCartVariants.has(Number(checkbox.value));
if (!available) setItemState(checkbox, 'unavailable', dialog.dataset.unavailableText);
else if (alreadyInCart) setItemState(checkbox, 'in-cart', dialog.dataset.alreadyText);
else setItemState(checkbox, 'ready', '');
});
updateButtonState();
return cart;
};
const closeDialog = (trackSkip = false) => {
if (!dialog.open) return;
dialog.close();
document.documentElement.classList.remove('hairify-upsell-open');
setFeedback('');
checkboxes.forEach((checkbox) => { if (!checkbox.disabled) checkbox.checked = false; });
updateButtonState();
if (trackSkip) track('upsell_skip');
if (restoreFocusTo && typeof restoreFocusTo.focus === 'function') restoreFocusTo.focus();
};
const openDialog = async () => {
if (dialog.open) return;
try { await syncWithCart(); } catch (_) {
checkboxes.forEach((checkbox) => { if (!checkbox.disabled) checkbox.checked = false; });
updateButtonState();
}
const cartDrawer = document.querySelector('cart-drawer');
if (cartDrawer && typeof cartDrawer.close === 'function') cartDrawer.close();
const cartNotification = document.querySelector('cart-notification');
if (cartNotification && typeof cartNotification.close === 'function') cartNotification.close();
restoreFocusTo = document.activeElement;
dialog.showModal();
document.documentElement.classList.add('hairify-upsell-open');
closeButton.focus();
track('upsell_popup_view');
};
const addedFiber = (event) => {
if (!event || event.source !== 'product-form') return false;
const productId = Number(event.cartData?.product_id || event.cartData?.items?.[0]?.product_id || 0);
const variantId = Number(event.productVariantId || event.cartData?.variant_id || event.cartData?.id || 0);
return productId === fiberProductId || fiberVariantIds.has(variantId);
};
const fiberFormSelector = 'product-form form[action*="/cart/add"], form[data-type="add-to-cart-form"]';
const stickySelector = [
  '[data-hairify-sticky-add]',
  '[data-essential-cart-element="add-to-cart-button"]',
  '[data-essential-cart-element="add-to-cart-button-text"]',
  '.essential_sticky_cart .esc-add-to-cart',
  '.essential_sticky_cart button',
  '.essential-sticky-cart button',
  '.shopify-payment-button__button'
].join(',');
let directFiberAddBusy = false;

const getFiberForm = () => document.querySelector(fiberFormSelector);
const isFiberForm = (form) => {
  if (!(form instanceof HTMLFormElement)) return false;
  return fiberVariantIds.has(Number(form.querySelector('[name="id"]')?.value || 0));
};

const addFibersWithoutRedirect = async (form, forcedQuantity = null) => {
  if (directFiberAddBusy || !isFiberForm(form)) return;
  directFiberAddBusy = true;

  const variantId = Number(form.querySelector('[name="id"]')?.value || 0);
  const body = new FormData(form);
  const associatedQuantity = form.id
    ? document.querySelector('[name="quantity"][form="' + CSS.escape(form.id) + '"]')
    : null;
  const stickyPackage = document.querySelector('[data-hairify-sticky-package]');
  const quantity = Math.max(
    1,
    Number(
      forcedQuantity ||
      body.get('quantity') ||
      associatedQuantity?.value ||
      stickyPackage?.value ||
      1
    )
  );
  body.set('id', String(variantId));
  body.set('quantity', String(quantity));

  const cartSurface = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  if (cartSurface && typeof cartSurface.getSectionsToRender === 'function') {
    const sectionIds = cartSurface.getSectionsToRender().map((section) => section.id);
    if (sectionIds.length) body.set('sections', sectionIds.join(','));
    body.set('sections_url', window.location.pathname);
  }

  try {
    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'add');

    if (cartSurface && typeof cartSurface.renderContents === 'function' && data.sections) {
      try { cartSurface.renderContents(data); } catch (_) {}
    }
    if (cartSurface && typeof cartSurface.close === 'function') {
      try { cartSurface.close(); } catch (_) {}
    }
    await refreshCartIcon();
    lastKnownFiberQuantity = (lastKnownFiberQuantity || 0) + quantity;
    lastFiberTriggerAt = Date.now();
    track('hairify_fiber_add_intercepted', { product_id: fiberProductId, variant_id: variantId, quantity });
    window.setTimeout(openDialog, 80);
  } catch (_) {
    const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const message = wrapper?.querySelector('.product-form__error-message');
    if (wrapper && message) {
      wrapper.hidden = false;
      message.textContent = window.cartStrings?.error || 'Produsul nu a putut fi adăugat în coș.';
    }
  } finally {
    directFiberAddBusy = false;
  }
};

if (window.location.pathname.indexOf('/products/hairify-fibre-de-par') !== -1) {
  const hairifyStickyInit = () => {
    const stickyBar = document.querySelector('[data-hairify-sticky-cart]');
    if (!stickyBar) return;

    const stickyButton = stickyBar.querySelector('[data-hairify-sticky-add]');
    const priceLabel = stickyBar.querySelector('[data-hairify-sticky-price]');
    const colorSelect = stickyBar.querySelector('[data-hairify-sticky-color]');
    const packageSelect = stickyBar.querySelector('[data-hairify-sticky-package]');
    const variantDataNode = stickyBar.querySelector('[data-hairify-sticky-variants]');
    let variants = [];

    try { variants = JSON.parse(variantDataNode?.textContent || '[]'); } catch (_) {}
    const byId = new Map(variants.map((variant) => [Number(variant.id), variant]));
    const bundleChoices = new Map();
    let bundleScanTimer = null;

    const normalizeText = (value) =>
      String(value || '').replace(/\s+/g, ' ').trim();

    const extractFinalPrice = (text) => {
      const matches = normalizeText(text).match(/\d{1,4}(?:[.\s]\d{3})*[,.]\d{2}\s*(?:RON|lei)/gi);
      return matches?.length ? matches[matches.length - 1] : '';
    };

    const getBundleRoots = () => {
      const explicit = Array.from(document.querySelectorAll(
        '[class*="bundlex" i], [id*="bundlex" i], [data-bundlex], [data-app*="bundlex" i]'
      ));

      if (explicit.length) return explicit;

      const inferred = Array.from(document.querySelectorAll('body *')).filter((element) => {
        const signature = [
          element.id || '',
          typeof element.className === 'string' ? element.className : '',
          ...Array.from(element.attributes || []).map((attr) => attr.name + '=' + attr.value)
        ].join(' ');
        return /bundlex|volume[-_ ]?discount|bundle[-_ ]?offer/i.test(signature);
      }).slice(0, 40);

      return inferred.length ? inferred : [document.body];
    };

    const identifyBundleQuantity = (text) => {
      const value = normalizeText(text).toLowerCase();
      const patterns = [
        /(?:^|\D)([123])\s*(?:x|buc(?:ată|ăți|ati)?|hairify|flacoane?|recipiente?|pcs?|pieces?|units?)/i,
        /(?:pachet|pack|bundle)\s*([123])(?:\D|$)/i,
        /^([123])(?:\D|$)/
      ];

      for (const pattern of patterns) {
        const match = value.match(pattern);
        if (match) return Number(match[1]);
      }
      return 0;
    };

    const clickableFor = (element) => {
      if (!element) return null;
      if (element.matches('input[type="radio"], input[type="checkbox"], button, [role="radio"], [role="button"], label')) return element;
      return element.closest('label, button, [role="radio"], [role="button"]') ||
        element.querySelector('input[type="radio"], input[type="checkbox"], button, [role="radio"], [role="button"], label') ||
        element;
    };

    const updatePackageOption = (quantity, priceText) => {
      const option = packageSelect?.querySelector('option[value="' + quantity + '"]');
      if (!option) return;

      if (priceText) {
        option.textContent = quantity + (quantity === 1 ? ' buc. — ' : ' buc. — ') + priceText;
        option.dataset.bundlePrice = priceText;
      }
    };

    const scanBundleX = () => {
      bundleChoices.clear();

      const roots = getBundleRoots();
      const candidates = [];

      roots.forEach((root) => {
        if (!root || root.closest('[data-hairify-sticky-cart]')) return;

        const selector = root === document.body
          ? 'label, button, [role="radio"], [role="button"], input[type="radio"], input[type="checkbox"], [class*="bundle" i], [class*="offer" i], [class*="volume" i]'
          : 'label, button, [role="radio"], [role="button"], input[type="radio"], input[type="checkbox"], div';

        const elements = [
          root,
          ...Array.from(root.querySelectorAll(selector))
        ];

        elements.forEach((element) => {
          const text = normalizeText(element.innerText || element.textContent || element.getAttribute?.('aria-label') || '');
          const quantity = identifyBundleQuantity(text);
          if (!quantity || quantity > 3) return;

          const price = extractFinalPrice(text);
          candidates.push({ quantity, price, element: clickableFor(element), text });
        });
      });

      [1, 2, 3].forEach((quantity) => {
        const matches = candidates.filter((candidate) => candidate.quantity === quantity);
        const priced = matches.find((candidate) => candidate.price);
        const best = priced || matches[0];
        if (!best) return;

        bundleChoices.set(quantity, best);
        if (best.price) updatePackageOption(quantity, best.price);
      });

      const currentQty = Number(packageSelect?.value || 1);
      const currentChoice = bundleChoices.get(currentQty);
      if (currentChoice?.price && priceLabel) priceLabel.textContent = currentChoice.price;
    };

    const setMainQuantity = (quantity) => {
      const form = getFiberForm();
      if (!form) return;

      const candidates = [
        form.querySelector('[name="quantity"]'),
        form.id ? document.querySelector('[name="quantity"][form="' + CSS.escape(form.id) + '"]') : null,
        document.querySelector('quantity-input input[name="quantity"]')
      ].filter(Boolean);

      candidates.forEach((input) => {
        input.value = String(quantity);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    const activateBundleChoice = (quantity) => {
      setMainQuantity(quantity);

      const choice = bundleChoices.get(quantity);
      if (choice?.price && priceLabel) {
        priceLabel.textContent = choice.price;
      }
    };

    const prepareStickySelection = async () => {
      const form = getFiberForm();
      if (!form) return { quantity: 1, variantId: 0 };

      const variantId = Number(colorSelect?.value || form.querySelector('[name="id"]')?.value || 0);
      const quantity = Math.max(1, Math.min(3, Number(packageSelect?.value || 1)));

      const variant = byId.get(variantId);
      if (variant) {
        const idInput = form.querySelector('[name="id"]');
        if (idInput) {
          idInput.value = String(variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      setMainQuantity(quantity);

      await new Promise((resolve) => window.setTimeout(resolve, 60));
      setMainQuantity(quantity);

      return { quantity, variantId };
    };

    stickyBar.hairifyPrepareSelection = prepareStickySelection;

    const applyColorToMainProduct = (variantId) => {
      const variant = byId.get(Number(variantId));
      if (!variant) return;

      const mainPicker = document.querySelector(
        'variant-selects select, product-info variant-selects select, select[name^="options"]'
      );

      if (mainPicker) {
        const matchingOption = Array.from(mainPicker.options).find(
          (option) => normalizeText(option.value) === normalizeText(variant.title) ||
                      normalizeText(option.textContent) === normalizeText(variant.title)
        );

        if (matchingOption) {
          mainPicker.value = matchingOption.value;
          mainPicker.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      window.setTimeout(() => {
        const form = getFiberForm();
        const idInput = form?.querySelector('[name="id"]');
        if (idInput && Number(idInput.value) !== Number(variant.id)) {
          idInput.value = String(variant.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 80);
    };

    const syncStickyVariant = () => {
      const form = getFiberForm();
      const variantId = Number(form?.querySelector('[name="id"]')?.value || 0);
      const variant = byId.get(variantId);
      if (!variant) return;

      if (colorSelect && Number(colorSelect.value) !== variantId) {
        colorSelect.value = String(variantId);
      }

      const selectedPackage = Number(packageSelect?.value || 1);
      const bundleChoice = bundleChoices.get(selectedPackage);

      if (priceLabel) {
        priceLabel.textContent = bundleChoice?.price || variant.price || '';
      }

      updatePackageOption(1, variant.price || '');

      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? 'Adaugă în coș' : 'Indisponibil';
      }
    };

    colorSelect?.addEventListener('change', () => {
      applyColorToMainProduct(Number(colorSelect.value));
      window.setTimeout(syncStickyVariant, 140);
    });

    packageSelect?.addEventListener('change', () => {
      const quantity = Math.max(1, Math.min(3, Number(packageSelect.value || 1)));
      activateBundleChoice(quantity);

      const choice = bundleChoices.get(quantity);
      if (choice?.price && priceLabel) {
        priceLabel.textContent = choice.price;
      }
    });

    const mainButton = document.querySelector('product-form button[type="submit"][name="add"]');

    if ('IntersectionObserver' in window && mainButton) {
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        },
        { threshold: 0.12 }
      );
      observer.observe(mainButton);
    } else {
      stickyBar.classList.add('is-visible');
    }

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return;

      if (
        target.name === 'id' ||
        target.classList.contains('product-variant-id') ||
        target.matches('variant-selects select, select[name^="options"]')
      ) {
        window.setTimeout(syncStickyVariant, 60);
      }
    }, true);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(syncStickyVariant, 60));
    }

    const runBundleScan = () => {
      scanBundleX();
      syncStickyVariant();
    };

    runBundleScan();
    window.setTimeout(runBundleScan, 400);
    window.setTimeout(runBundleScan, 1000);
    window.setTimeout(runBundleScan, 2200);
  };
  hairifyStickyInit();

  window.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const nativeAdd = event.target.closest(
      'product-form button[type="submit"][name="add"], form[data-type="add-to-cart-form"] button[type="submit"][name="add"]'
    );
    const stickyAdd = event.target.closest(stickySelector);
    if (!nativeAdd && !stickyAdd) return;

    const form = nativeAdd?.closest('form') || getFiberForm();
    if (!isFiberForm(form)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    let forcedQuantity = null;
    const nativeHairifySticky = event.target.closest('[data-hairify-sticky-add]');

    if (nativeHairifySticky) {
      const stickyBar = nativeHairifySticky.closest('[data-hairify-sticky-cart]');
      if (stickyBar?.hairifyPrepareSelection) {
        const selection = await stickyBar.hairifyPrepareSelection();
        forcedQuantity = selection?.quantity || null;
      }
    }

    addFibersWithoutRedirect(form, forcedQuantity);
  }, true);

  window.addEventListener('submit', (event) => {
    const form = event.target;
    if (!isFiberForm(form)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    addFibersWithoutRedirect(form);
  }, true);
}

getCart().then((cart) => { lastKnownFiberQuantity = getFiberQuantity(cart); }).catch(() => {});
checkboxes.forEach((checkbox) => {
checkbox.checked = false;
checkbox.addEventListener('change', () => {
updateButtonState();
track('upsell_product_select', { variant_id: Number(checkbox.value), product_title: checkbox.dataset.productTitle || '', selected: checkbox.checked });
});
});
addButton.addEventListener('click', async () => {
const selected = checkboxes.filter((checkbox) => checkbox.checked && !checkbox.disabled);
if (!selected.length) { closeDialog(false); return; }
addButton.disabled = true;
addButton.textContent = dialog.dataset.loadingText;
setFeedback('');
let latestCart;
try { latestCart = await getCart(); } catch (_) { latestCart = { items: [] }; }
const existingVariants = new Set(latestCart.items.map((item) => Number(item.variant_id)));
const skippedExisting = selected.filter((checkbox) => existingVariants.has(Number(checkbox.value)));
const pending = selected.filter((checkbox) => !existingVariants.has(Number(checkbox.value)));
const successful = new Set();
const failed = new Set();
skippedExisting.forEach((checkbox) => setItemState(checkbox, 'in-cart', dialog.dataset.alreadyText));
if (pending.length) {
try {
const bulkResponse = await fetch(window.routes.cart_add_url, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
body: JSON.stringify({ items: pending.map((checkbox) => ({ id: Number(checkbox.value), quantity: 1 })) })
});
if (bulkResponse.ok) pending.forEach((checkbox) => successful.add(Number(checkbox.value)));
else throw new Error('bulk');
} catch (_) {
let cartAfterBulk;
try { cartAfterBulk = await getCart(); } catch (_) { cartAfterBulk = { items: [] }; }
const presentAfterBulk = new Set(cartAfterBulk.items.map((item) => Number(item.variant_id)));
for (const checkbox of pending) {
const variantId = Number(checkbox.value);
if (presentAfterBulk.has(variantId)) { successful.add(variantId); continue; }
try {
const response = await fetch(window.routes.cart_add_url, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
body: JSON.stringify({ id: variantId, quantity: 1 })
});
if (response.ok) successful.add(variantId); else failed.add(variantId);
} catch (_) { failed.add(variantId); }
}
}
}
checkboxes.forEach((checkbox) => {
const variantId = Number(checkbox.value);
if (successful.has(variantId)) setItemState(checkbox, 'in-cart', dialog.dataset.addedText);
if (failed.has(variantId)) setItemState(checkbox, 'unavailable', dialog.dataset.errorText);
});
await refreshCartIcon();
track('upsell_add', { variant_ids: Array.from(successful), added_count: successful.size, failed_count: failed.size });
if (successful.size && !failed.size) {
setFeedback(dialog.dataset.successText, 'success');
track('upsell_checkout_redirect', { added_count: successful.size });
window.setTimeout(() => {
window.location.assign('/checkout');
}, 350);
} else if (successful.size) setFeedback(dialog.dataset.partialErrorText, 'error');
else if (failed.size) setFeedback(dialog.dataset.errorMessageText, 'error');
else setFeedback(dialog.dataset.alreadyText, 'success');
addButton.textContent = dialog.dataset.addLabel;
updateButtonState();
});
skipButton.addEventListener('click', () => {
  closeDialog(true);
  track('upsell_checkout_redirect', { added_count: 0 });
  window.location.assign('/checkout');
});
closeButton.addEventListener('click', () => closeDialog(true));
dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeDialog(true); });
dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(true); });
updateButtonState();
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
else init();
})();